var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHoticon = function SvgHoticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.63 2.224a1 1 0 0 0-1.438.187L6.47 6.135l-.765-.424a1 1 0 0 0-1.47.703c-.117.675-.699 4.087-.699 5.022C3.536 15.545 6.822 18 10 18c3.178 0 6.464-2.455 6.464-6.563 0-4.423-5.595-9.02-5.833-9.213ZM10 16a2.169 2.169 0 0 1-2.167-2.166c0-1.825 1.736-3.61 1.81-3.684a.514.514 0 0 1 .713 0c.075.074 1.81 1.859 1.81 3.684A2.169 2.169 0 0 1 10 16Z"
  })));
};
export default SvgHoticon;